const CHANNEL_NAME = 'octane-auth'
const listeners = new Set<() => void>()
let channel: BroadcastChannel | undefined

function getChannel(): BroadcastChannel | undefined {
    if (channel) return channel

    if (
        typeof window === 'undefined' ||
        typeof window.BroadcastChannel !== 'function'
    ) {
        return undefined
    }

    try {
        channel = new window.BroadcastChannel(CHANNEL_NAME)

        channel.onmessage = ({ data }: MessageEvent<unknown>) => {
            if (
                data &&
                typeof data === 'object' &&
                'type' in data &&
                data.type === 'logout'
            ) {
                for (const listener of listeners) listener()
            }
        }
    } catch {
        return undefined
    }

    return channel
}

function closeUnusedChannel(): void {
    if (listeners.size) return

    channel?.close()
    channel = undefined
}

export function subscribeToAuthLogout(listener: () => void): () => void {
    if (!getChannel()) return () => undefined

    listeners.add(listener)

    return () => {
        listeners.delete(listener)
        closeUnusedChannel()
    }
}

export function broadcastAuthLogout(): void {
    try {
        getChannel()?.postMessage({ type: 'logout' })
    } catch {
        // Cross-tab messaging must not prevent local logout.
    } finally {
        closeUnusedChannel()
    }
}
